<template>
    <div>
        <div class="content-page" v-if=storedStatusJWT>
            <h2 class="text-center pt2 pb-4">Профиль</h2>

            <div class="align-content-center text-center">

                <div class="mt-2">
                    <b-card-group deck class="pb-4">

                        <b-card header-bg-variant="light" class="text-center">
                            <template #header class="card-header">
                                <h4 class="mb-0 text-bold">Ваши данные</h4>
                            </template>
                            <b-card-text>
                                <div>
                                    <template>
                                        <div class="text-center">
                                            <div><b>ФИО:</b> {{ this.profile.name }}.</div>
                                            <div><b>Страна:</b> {{ this.profile.country }}.</div>
                                            <div><b>Город:</b> {{ this.profile.city }}.</div>
                                            <div><b>Email:</b> {{ this.profile.email }}.</div>
                                            <div><b>Телефон:</b> {{ this.profile.tel }}.</div>
                                            <div><b>Валюта:</b> {{ this.profile.curr }}.</div>
                                        </div>
                                    </template>
                                </div>
                            </b-card-text>
                        </b-card>

                        <b-card header-bg-variant="light" class="text-center">
                            <template #header class="card-header">
                                <h4 class="mb-0 text-bold">Смена пароля</h4>
                            </template>
                            <b-card-text>
                                <div>
                                    <form @submit.prevent="changePassword">
                                        <div class="row">
                                            <label>
                                                Если нужно поменять пароль, введите в поле и нажмите "сохранить
                                                пароль".
                                                Произойдет редирект на страницу входа, вход уже будет по новому
                                                паролю.
                                                Поэтому желательно внимательно проверить и запомнить что ввели.
                                            </label>
                                            <div class="form-group m-auto">
                                                <input required v-model="password" type="text" class="form-control"/>
                                                <button type="submit" class="btn btn-success btn-lg btn-block">сохранить
                                                    пароль
                                                </button>

                                            </div>

                                        </div>
                                    </form>
                                    <div class="mt-4">
                                        {{ this.info }}
                                    </div>
                                </div>
                            </b-card-text>
                        </b-card>

                    </b-card-group>
                </div>

            </div>
        </div>


    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import Cookies from "js-cookie";


export default {
    data: () => ({
        profile: {},
        password: '',
        info: ''
    }),
    computed: {
        ...mapGetters([
            'storedStatusJWT'
        ])
    },
    created() {
        if (this.storedStatusJWT) {
            this.axios
                .get('/api/profile')
                .then(response => {
                    this.profile = response.data.info;
                    console.log(this.profile)
                })
        } else {
            window.location.href = '/home';
        }
    },
    methods: {
        changePassword: function () {
            const {password} = this
            axios
                .post('../api/change_password', {password})
                .then(response => {
                    console.log(response.data)
                    if (response.data === true) {
                        Cookies.remove('JWT');
                        window.location.href = "/home/";
                    } else {
                        this.info = "Что то пошло не так... Просьба связаться с администратором."
                    }
                })
        }
    }
}
</script>
<style>

.card-deck .card {
    box-shadow: 1px 5px 5px #dae0e5;
}

.card-deck {
    margin-right: 1px;
    margin-left: 1px;
}
</style>
